// extracted by mini-css-extract-plugin
export default {"w-full":"TopCountry_w-full__CqBOJ","chart":"TopCountry_chart__u4+BP"};